import { render, staticRenderFns } from "./Penalty.vue?vue&type=template&id=431787aa&"
import script from "./Penalty.vue?vue&type=script&lang=js&"
export * from "./Penalty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports